import request from "./request";

//测试报告
export function getTestReportData(uuid) {
    return request({
        url: `/student/test/report/${uuid}`,
        method: "GET",
    });
}